define('dealerSeo',[
  'jquery',
  'lib/util/buildGoTo',
  'zipTools'
], function (
  $,
  buildGoTo,
  zipTools
) {
  window.dealerSeo = {
    init: function () {
      if ($('div.dealer-page-content').length) {
        var columns = 2;
        var $ul = $('ul.vertical-list');
        var $elements = $ul.children('li');
        var breakPoint = Math.ceil($elements.length / columns);
        $ordered = $('<div></div>');

        function appendToUL(i) {
          if ($ul.children().eq(i).length > 0) {
            $ordered.append($ul.children().eq(i).clone());
          } else {
            $ordered.append($('<li class="hidden"><a href="#"></a></li>'));
          }
        }

        function reorder($el) {
          $el.each(function () {
            $item = $(this);
            if ($item.index() >= breakPoint) return false;
            appendToUL($item.index());
            for (var i = 1; i < columns; i++) {
              appendToUL(breakPoint * i + $item.index());
            }
          });

          $ul.html($ordered.children().css('width', 100 / columns + '%'));
        }

        reorder($elements);
      }

      if ($('div.dealer-states-page-content').length) {
        var columns = 3;
        var $ul = $('ul.vertical-list');
        var $elements = $ul.children('li');
        var breakPoint = Math.ceil($elements.length / columns);
        $ordered = $('<div></div>');

        function appendToUL(i) {
          if ($ul.children().eq(i).length > 0) {
            $ordered.append($ul.children().eq(i).clone());
          } else $ordered.append($('<li class="hidden"><a href="#"></a></li>'));
        }

        function reorder($el) {
          $el.each(function () {
            $item = $(this);

            if ($item.index() >= breakPoint) return false;

            appendToUL($item.index());
            for (var i = 1; i < columns; i++) {
              appendToUL(breakPoint * i + $item.index());
            }
          });

          $ul.html($ordered.children().css('width', 100 / columns + '%'));
        }

        reorder($elements);
      }

      var lang = SU.getLangFromUrl();
      if (lang === 'es') {
        $('ul#dealer-directory-cities-list a[data-tda-code]').each(function (index) {
          var spanishURL = '/es' + $(this).attr('href');
          $(this).attr('href', spanishURL);
          // console.log(index + ": " + $(this).attr('href'));
        });
      }

      $('#dealer-directory-cities-list-mobile').on('change', function (e) {
        var listOfValues = this.value.split('|');
        var siteContext = listOfValues[0];
        var zip = listOfValues[1];
        var tdaCode = listOfValues[2];
        var es = '';
        if (SU.getLangFromUrl() === 'es') {
          es = '/es';
        }
        var url = es + '/' + siteContext + '/dealers/index.page?zipcode=' + zip + '&tdaCode=' + tdaCode;
        var currentTdaCode = SU.getTDA();
        if (currentTdaCode !== tdaCode) {
          e.preventDefault();
          zipTools.showTDARedirectModal(function () {
            if (tdaCode.toUpperCase() === 'SET10') {
              window.location.href = 'https://www.buyatoyota.com/southeasttoyota/';
            } else {
              var gotourl = buildGoTo(tdaCode, url);
              window.location.href = gotourl;
            }
          });
        } else {
          if (tdaCode.toUpperCase() === 'SET10') {
            window.location.href = 'https://www.buyatoyota.com/southeasttoyota/';
          } else {
            window.location.href = url;
          }
        }
      });
      $('ul#dealer-directory-cities-list a[data-tda-code]').on('click', zipTools.warnOnTDAChange);

      window.bat.util.loader.hideLoader();
    } // end init
  }; // end seoMaps var

  $(window).on('loaded', function () {
    if ($('div.dealer-page-content').length || $('div.dealer-states-page-content').length) {
      dealerSeo.init();
    } else {
      window.bat.util.loader.hideLoader();
    }
  });
});

